export default {
  SET_userFile(state, value) {
    state.userFile = value;
  },
};
